export default __webpack_public_path__ + "static/media/danica-logo.f563bcb8.svg";